import React from "react";
import { useFormContext } from "react-hook-form";
import { useCheckoutBasicDetailsContext } from "repoV2/features/CheckoutPages/modules/CheckoutBasicDetailsContextProvider";
import { ISlotDetails } from "repoV2/features/CheckoutPages/utils/apis/SessionDetailsApi/SessionDetailsApi.interface";
import { getSelectedSessionDetailsFieldName } from "../../../../SessionDetailsFormGroup.utils";

export const useSingleSession = ({ session }: { session: ISlotDetails }) => {
    const { listingUuid, listingType } = useCheckoutBasicDetailsContext();
    const { setValue } = useFormContext();

    React.useEffect(() => {
        const fieldName = getSelectedSessionDetailsFieldName({
            listingUuid,
            listingType,
        });
        setValue(fieldName, [session.uuid]);
    }, [session.uuid]);
};
